import React from 'react';

import Hero from './sections/Hero';
import About from './sections/About';
import Features from './sections/Features';
// TEMPORARILY DISABLED: HowItWorks home-page section. Re-enable by uncommenting.
// eslint-disable-next-line no-unused-vars
import HowItWorks from './sections/HowItWorks';
import StepOne from './sections/StepOne';
import StepTwo from './sections/StepTwo';
import Why from './sections/Why';

import styles from './Home.styles';
import Testimonials from './sections/Testimonials';
import App from './sections/App';
import Seo from "../../components/Seo";
import { useI18n } from "../../i18n";

export default function Home() {
  const { t } = useI18n();
    return (
        <div className={`${styles.container}`}>
      <Seo title={t("seo_home_title")} description={t("seo_home_desc")} />
            <Hero/>
            <Features/>
            <About/>
            {/* TEMPORARILY DISABLED: HowItWorks home-page section. Re-enable by uncommenting. */}
            {/* <HowItWorks/> */}
            <StepOne/>
            <StepTwo/>
            <Why/>
            <Testimonials/>
            <App/>
        </div>
    );
}
